
const imageUrl = (title) => {
  return `/imgs/case/optimize/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    title: '使用产品：EPLD',
    description: '某世界500强连锁企业，以营业额计算为全球最大的公司；公司的业务之所以能够迅速增长，并且成为知名\n' +
      '公司之一，是因为该公司在节省成本以及在物流配送系统与供应链管理方面取得了巨大的成就。'
  },
  method: imageUrl('method'),
  value: [
    {
      title: '价值一',
      description: '国内领先的算法，成本可以降低20%。',
      img: imageUrl('value1')
    },
    {
      title: '价值二',
      description: '减少50%的人工工作量，提高工作效率。',
      img: imageUrl('value2')
    },
    {
      title: '价值三',
      description: '系统+人工相结合的优化方式，优化准确率可以无限接近100%。',
      img: imageUrl('value3')
    },
    {
      title: '价值四',
      description: '充分利用历史配载结果库，运算速度比同类产品快50%。',
      img: imageUrl('value4')
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/optimize.js